import { DashboardMetricTile } from "@/dashboard/components/dashboard-ds";
import { formatToLocaleString } from "@/core/utils/formatters";
import { InsightsConsumption } from "./insights-consumption.types";
import { useTranslation } from "react-i18next";
import { formatMonthName, useIntlLocale } from "@/core/utils/locale";

/**
 * Consumo do mês atual x média dos últimos meses, em dois tiles lado a lado
 * (Figma "Demanda estável", 6084:6264).
 */
export function InsightsConsumptionTimeline({
  data,
}: {
  data: InsightsConsumption;
}) {
  const [translate] = useTranslation(["dashboard-charts"]);
  const creditsLabel = translate("dashboard-credits-label-text") as string;
  // Mês corrente no idioma do app (pt-BR: "outubro"); o overline do tile
  // deixa em caixa alta. O `dayjs` global fica em inglês ("October").
  const locale = useIntlLocale();
  const currentMonth = formatMonthName(new Date().getMonth() + 1, locale);

  return (
    <div
      className="grid grid-cols-2 gap-2"
      data-testid="insights-consumption-metrics"
    >
      <DashboardMetricTile
        overline={currentMonth}
        value={formatToLocaleString(data.current)}
        caption={creditsLabel}
      />
      <DashboardMetricTile
        overline={translate("dashboard-consumption-average") as string}
        value={formatToLocaleString(data.average)}
        caption={creditsLabel}
      />
    </div>
  );
}
